import type { BankAccountType } from '@api';
import { Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { BankAccountFormSchemaType } from '../../common/hooks';
import { EditBankAccountForm } from './components';

export type EditBankAccountModalPropsType = {
  opened: boolean;
  onClose: () => void;
  bankAccount: BankAccountType | null;
  onSubmitUpdate: (
    data: BankAccountFormSchemaType,
    bankAccountId: string
  ) => Promise<void>;
};

export const EditBankAccountModal: React.FC<EditBankAccountModalPropsType> = ({
  opened,
  onClose,
  bankAccount,
  onSubmitUpdate,
}) => {
  const { t } = useTranslation('common');

  const handleSubmit = async (
    data: BankAccountFormSchemaType
  ): Promise<void> => {
    if (!bankAccount) return;
    await onSubmitUpdate(data, bankAccount.id);
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="lg"
      title={t('EDIT_BANK_ACCOUNT_MODAL.TITLE')}
    >
      {bankAccount && (
        <EditBankAccountForm
          key={bankAccount.id}
          bankAccount={bankAccount}
          onSubmit={handleSubmit}
          onClose={onClose}
        />
      )}
    </Modal>
  );
};
